import { config } from 'Shared/Services/environment.service';
import { useTranslation } from 'next-i18next';
import { useEffect } from 'react';

interface Props {
  id: string;
  formId: string;
  inlineMessage?: string;
  onSubmit?: () => void;
}

const HubspotForm = (props: Props) => {
  const { id, formId, inlineMessage, onSubmit } = props;
  const { t } = useTranslation();

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/v2.js';
    document.body.appendChild(script);

    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: config('NX_NEXT_PUBLIC_HUBSPOT_PORTAL_ID'),
          formId: formId,
          target: `#${id}`,
          inlineMessage: inlineMessage || t('hubspot.formFeedback'),
          onFormSubmit: onSubmit,
        });
      }
    });
  }, []);

  return <div id={id} />;
};

export { HubspotForm };
